import { FunctionComponent } from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { RadioGroupWithRegister } from "src/components/inputs";
import { NEATTOptions } from "src/utils/types";

interface IFinancialHistoryFormProps {
  register: UseFormRegister<any>
  errors: FieldErrors;
  appliedForLoan: string;
  foreclose: string;
}

const FinancialHistoryForm: FunctionComponent<IFinancialHistoryFormProps> = ({ register, errors, appliedForLoan, foreclose }) => (
  <form className="grid grid-cols-3 gap-8">
    <RadioGroupWithRegister
      question="Have you had your credit pulled in the last 12 months?"
      name="checkedCreditInLastYear"
      register={register}
      options={NEATTOptions.YesNoUnsureOptions}
      error={`${errors?.checkedCreditInLastYear?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Have you ever applied for a loan?"
      name="applied"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.applied?.message || ""}`}
    />

    {appliedForLoan === NEATTOptions.YesNoUnsure.YES && (
      <RadioGroupWithRegister
        question="Have you ever been denied a loan?"
        name="denied"
        register={register}
        options={NEATTOptions.YesNoOptions}
        error={`${errors?.denied?.message || ""}`}
      />
    )}

    <RadioGroupWithRegister
      question="Have you ever had a foreclosure, repossession, declared Bankruptcy, Tax issues?"
      name="foreclosureOrDefault"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.foreclosureOrDefault?.message || ""}`}
    />

    {foreclose === NEATTOptions.YesNoUnsure.YES && (
      <RadioGroupWithRegister
        question="Which?"
        name="reason"
        register={register}
        options={NEATTOptions.reasonForDefaultOptions}
        error={`${errors?.reason?.message || ""}`}
      />
    )}

    <RadioGroupWithRegister
      question="Has anyone co-signed or guaranteed a loan for you?"
      name="cosignerOrGuaranteeForClient"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.cosignerOrGuaranteeForClient?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Have you co-signed or guaranteed any loans?"
      name="cosignerOrGuaranteeForOther"
      register={register}
      options={NEATTOptions?.YesNoOptions}
      error={`${errors?.cosignerOrGuaranteeForOther?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Do you have any collections or judgments on your credit report?"
      name="collectionsOrJudgements"
      register={register}
      options={NEATTOptions.YesNoUnsureOptions}
      error={`${errors?.collectionsOrJudgements?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Are you currently behind on any loan or bill payments?"
      name="behindOnPayments"
      register={register}
      options={NEATTOptions.YesNoUnsureOptions}
      error={`${errors?.behindOnPayments?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Are you currently using more than 30% of your available credit?"
      name="using30Percent"
      register={register}
      options={NEATTOptions.YesNoUnsureOptions}
      error={`${errors?.using30Percent?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Do you have any student loan debt?"
      name="studentLoanDebt"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.studentLoanDebt?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Are you aware of your current credit score range?"
      name="awareOfCreditScore"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.awareOfCreditScore?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Have you placed a block on your credit report?*"
      name="placedBlockOnCredit"
      register={register}
      options={NEATTOptions.YesNoUnsureOptions}
      error={`${errors?.placedBlockOnCredit?.message || ""}`}
    />
  </form>
);

export default FinancialHistoryForm;
